// We'll make VisualDebugger no-op for any environments lacking a DOM (e.g. SSR and React Native non-web platforms).
var hasDOM = typeof window !== 'undefined' && window.document;
var WIDTH = hasDOM ? window.innerWidth : 0;
var HEIGHT = hasDOM ? window.innerHeight : 0;
var VisualDebugger = /** @class */ (function () {
    function VisualDebugger() {
        if (hasDOM) {
            this.debugCtx = VisualDebugger.createCanvas('sn-debug', '1010');
            this.layoutsCtx = VisualDebugger.createCanvas('sn-layouts', '1000');
            var debugElem = document.getElementById('sn-debug');
            if (debugElem) {
                debugElem.style.pointerEvents = 'none';
            }
            var layoutsElem = document.getElementById('sn-layouts');
            if (layoutsElem) {
                layoutsElem.style.pointerEvents = 'none';
            }
        }
    }
    VisualDebugger.createCanvas = function (id, zIndex) {
        var canvas = document.querySelector("#".concat(id)) || document.createElement('canvas');
        canvas.setAttribute('id', id);
        var ctx = canvas.getContext('2d');
        canvas.style.zIndex = zIndex;
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        document.body.appendChild(canvas);
        canvas.width = WIDTH;
        canvas.height = HEIGHT;
        return ctx;
    };
    VisualDebugger.prototype.clear = function () {
        if (!hasDOM) {
            return;
        }
        if (this.debugCtx) {
            this.debugCtx.clearRect(0, 0, WIDTH, HEIGHT);
        }
    };
    VisualDebugger.prototype.clearLayouts = function () {
        if (!hasDOM) {
            return;
        }
        if (this.layoutsCtx) {
            this.layoutsCtx.clearRect(0, 0, WIDTH, HEIGHT);
        }
    };
    VisualDebugger.prototype.drawLayout = function (layout, focusKey, parentFocusKey) {
        if (!hasDOM || !this.layoutsCtx) {
            return;
        }
        this.layoutsCtx.strokeStyle = 'green';
        this.layoutsCtx.strokeRect(layout.left, layout.top, layout.width, layout.height);
        this.layoutsCtx.font = '15px monospace';
        this.layoutsCtx.fillStyle = 'red';
        this.layoutsCtx.fillText(focusKey, layout.left, layout.top + 10);
        this.layoutsCtx.fillText(parentFocusKey, layout.left, layout.top + 25);
        this.layoutsCtx.fillText("left: ".concat(layout.left), layout.left, layout.top + 40);
        this.layoutsCtx.fillText("top: ".concat(layout.top), layout.left, layout.top + 55);
    };
    VisualDebugger.prototype.drawPoint = function (x, y, color, size) {
        if (color === void 0) { color = 'blue'; }
        if (size === void 0) { size = 10; }
        if (!hasDOM || !this.debugCtx) {
            return;
        }
        this.debugCtx.strokeStyle = color;
        this.debugCtx.lineWidth = 3;
        this.debugCtx.strokeRect(x - size / 2, y - size / 2, size, size);
    };
    return VisualDebugger;
}());
export default VisualDebugger;
